import { Link } from "react-router-dom";
import ComicModel from "../../models/ComicModel";

export const CheckoutAndReviewBox: React.FC<{
	comic: ComicModel | undefined;
	mobile: boolean;
}> = (props) => {
	return (
		<div
			className={
				props.mobile
					? "card d-flex mt-5"
					: "card col-3 container d-flex mb-5"
			}
		>
			<div className="card-body container">
				<div className="mt-3">
					<p>
						<b>0/5 </b>
						Comics Checked Out
					</p>
					<hr></hr>
					{props.comic &&
					props.comic.copiesAvailable &&
					props.comic.copiesAvailable > 0 ? (
						<h4>Available</h4>
					) : (
						<h4>Waitlist</h4>
					)}
					<div className="row">
						<p className="col-6 lead">
							<b>{props.comic?.copies} Copies</b>
						</p>

						<p className="col-6 lead">
							<b>{props.comic?.copiesAvailable} In Stock</b>
						</p>
					</div>
				</div>
				<Link to="/#" className="btn btn-dark btn-lg">
					Sign In
				</Link>
				<hr />

				<p className="mt-3">
					This number can change until order is completed.
				</p>
				<p>Sign in to leave a review.</p>
			</div>
		</div>
	);
};
